/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ResizeImageOptions { 
    pxWidth?: number | null;
    pxHeight?: number | null;
    ignoreAspectRatio?: boolean | null;
    shrinkOnlyLargerImage?: boolean | null;
    enlargeOnlySmallerImage?: boolean | null;
    fillArea?: boolean | null;
}

